import type { ReactNode } from "react";
import { useEffect } from "react";
import { Spinner } from "@heroui/react";
import { Navigate, useLocation } from "react-router-dom";
import { useUserStore } from "@/entities/user";

export interface AuthGuardProps {
  children: ReactNode;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const location = useLocation();
  const { isAuthenticated, isLoading, clearUser } = useUserStore();

  // Защита от зависания: если запрос завис или ответа от сервера нет вовсе,
  // принудительно сбрасываем статус загрузки и перенаправляем на логин
  useEffect(() => {
    if (!isLoading) return;

    const timer = setTimeout(() => {
      console.warn("Проверка авторизации превысила лимит ожидания, перенаправление на /login");
      clearUser();
    }, 3500);

    return () => clearTimeout(timer);
  }, [isLoading, clearUser]);

  if (isLoading) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export const GuestGuard = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated } = useUserStore();

  // Если пользователь уже авторизован — отправляем на главную
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
